import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
export class EventMantenedorFocoService {
    constructor() {
        this.invokeFirstComponentFunction = new EventEmitter();
    }
    refreshTable() {
        this.invokeFirstComponentFunction.emit();
    }
}
EventMantenedorFocoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EventMantenedorFocoService_Factory() { return new EventMantenedorFocoService(); }, token: EventMantenedorFocoService, providedIn: "root" });
